import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import ModalContact from 'aulatime/src/components/ModalContact';
import SectionCursos from 'aulatime/src/components/SectionCursos';

const CoursesTable4 = () => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            station {
              metadata {
                domain
                shortcode
              }
            }
          }
        }
      }
    `
  );

  const postmanpConfig = {
    metadata: {
      ...data.site.siteMetadata.station.metadata,
      ...{ lang: process.env.GATSBY_LOCALE || 'en' },
      ...{ form: 'book', section: '#Courses' },
    },
  };

  const button = onClick => (
    <button type="button" className="btn btn-lg btn-primary" onClick={onClick}>
      Book Now!
    </button>
  );

  const col1 = (
    <div className="col">
      <div className="card card-01">
        <div className="card-header"></div>
        <div className="card-body">
          <div className="hour-comparison text-center">
            <div className="row justify-content-center">
              <div className="col-auto hours">
                <h4>Pay-as-you-go</h4>
                <h5 className="pt-2">1 hour</h5>
                <h6>of private tuition online</h6>
              </div>
            </div>
          </div>

          <div className="price text-center pt-3 pb-3">
            <h5>
              €49,<span>99</span>
            </h5>
            <p className="small">VAT incl.</p>
          </div>

          <div>
            <ModalContact
              button={button}
              postmanpConfig={postmanpConfig}
              plan="#1Hour"
            />
          </div>
        </div>
        <div className="card-footer"></div>
      </div>
    </div>
  );

  const col2 = (
    <div className="col">
      <div className="card card-02">
        <div className="card-header"></div>
        <div className="card-body">
          <div className="hour-comparison text-center">
            <div className="row justify-content-center">
              <div className="col-auto hours">
                <h4>Easy mini-plan</h4>
                <h5 className="pt-2">5 hours</h5>
                <h6>of private tuition online</h6>
              </div>
            </div>
          </div>

          <div className="price text-center pt-3 pb-3">
            <h5>
              €179,<span>99</span>
            </h5>
            <p className="small">VAT incl.</p>
          </div>

          <div>
            <ModalContact
              button={button}
              postmanpConfig={postmanpConfig}
              plan="#5Hours"
            />
          </div>
        </div>
        <div className="card-footer"></div>
      </div>
    </div>
  );

  const col3 = (
    <div className="col">
      <div className="card card-03">
        <div className="card-header"></div>
        <div className="card-body">
          <div className="hour-comparison text-center">
            <div className="row justify-content-center">
              <div className="col-auto hours">
                <h4>Starter plan</h4>
                <h5 className="pt-2">10 hours</h5>
                <h6>of private tuition online</h6>
              </div>
            </div>
          </div>

          <div className="price text-center pt-3 pb-3">
            <h5>
              €249,<span>99</span>
            </h5>
            <p className="small">VAT incl.</p>
          </div>

          <div>
            <ModalContact
              button={button}
              postmanpConfig={postmanpConfig}
              plan="#10Hours"
            />
          </div>
        </div>
        <div className="card-footer"></div>
      </div>
    </div>
  );

  const header = (
    <div className="container">
      <div className="row">
        <div className="col text-center">
          <h1 className="mb-0 pt-4">Flexible timetable</h1>
          <h2>To suit your busy schedule</h2>
          <h3 className="text-primary mb-0 pb-0">
            Cost-free reschedule for any missed classes
          </h3>
        </div>
      </div>
    </div>
  );

  return (
    <SectionCursos
      id="cursos-tabla-4"
      header={header}
      cols={[col1, col2, col3]}
    />
  );
};

export default CoursesTable4;
